// Skeleton loader shaped like a dashboard page: title, KPI strip, chart, table.
export default function PageSkeleton() {
  return (
    <div className="space-y-8 animate-fade" data-testid="page-skeleton" aria-busy="true">
      <div className="space-y-2.5">
        <div className="skel h-2.5 w-24" />
        <div className="skel h-5 w-64" />
      </div>
      <div className="border border-[var(--rule)] grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 divide-x divide-[var(--rule)]">
        {[...Array(6)].map((_, i) => (
          <div key={i} className="p-5 space-y-3">
            <div className="skel h-2.5 w-20" />
            <div className="skel h-7 w-16" />
          </div>
        ))}
      </div>
      <div className="border border-[var(--rule)] p-4 space-y-4">
        <div className="skel h-3 w-40" />
        <div className="skel h-48 w-full" />
      </div>
      <div className="border border-[var(--rule)]">
        {[...Array(5)].map((_, i) => (
          <div key={i} className="flex items-center gap-6 px-4 py-3.5 border-t border-[var(--rule)] first:border-t-0">
            <div className="skel h-3 w-1/3" />
            <div className="skel h-3 w-16" />
            <div className="skel h-3 w-20 ml-auto" />
          </div>
        ))}
      </div>
    </div>
  );
}
